module.exports = __webpack_public_path__ + "img/login_logo.e5f06317.png";